import { BrandTopicPage, CategoryPage, ErrorPage, HomePage, ProductPage } from 'pages';
import Paper from '@material-ui/core/Paper';
import NavBarContainer from 'features/NavBar';
import PropTypes from 'prop-types';
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import GlobalContainer from '../containers/GlobalContainer';
import styles from '../styles.css';

const muiStyles = theme => ({
	content: {
		padding: '0em 0em',
		flex: '1 0 auto',
		// Distributes the font to any underlying text
		fontFamily: theme.typography.fontFamily,
		color: theme.palette.text.primary,
	},
});

const App = ({ classes }) => {
	return <div className={styles.app}>
		<GlobalContainer />
		<NavBarContainer className={styles.header} />
		<Paper className={classes.content}>
			<Routes>
				<Route exact path="/" element={<HomePage />} />
				{/* on initial load the url is set to where the kiosk was served from */}
				<Route exact path="/kiosk/welcome" element={<HomePage />} />
				<Route exact path="/:lang/kiosk/welcome" element={<HomePage />} />
				<Route path="/topic/:id" element={<BrandTopicPage />} />
				<Route exact path="/category" element={<CategoryPage />} />
				<Route path="/category/:id" element={<CategoryPage />} />
				<Route path="/product/:id" element={<ProductPage />} />
				<Route path="/errorPage" element={<ErrorPage/>} />
			</Routes>
		</Paper>
	</div>
};

App.propTypes = {
	classes: PropTypes.shape({
		content: PropTypes.string,
	}).isRequired,
};

export default withStyles(muiStyles, { name: 'App' })(App);
